import { render, staticRenderFns } from "./IpcCity.vue?vue&type=template&id=789b1ac4&"
import script from "./IpcCity.vue?vue&type=script&lang=js&"
export * from "./IpcCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('789b1ac4')) {
      api.createRecord('789b1ac4', component.options)
    } else {
      api.reload('789b1ac4', component.options)
    }
    module.hot.accept("./IpcCity.vue?vue&type=template&id=789b1ac4&", function () {
      api.rerender('789b1ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/ipc-city/IpcCity.vue"
export default component.exports